import React from 'react';
import { StaticImage } from "gatsby-plugin-image"

const EmailWidget = ({ title, address }) => (
  <div className="rs-contact home-style1 home-style3 pt-20 pb-20 md-pt-15 md-pb-15">
    <div className="row y-middle">
      <div className="col-lg-8">
        <div className='widget-item mb-20'>
          <div className='widget-img'>
            <StaticImage
              src="../../images/contact/icons/2-2.png"
              loading="eager"
              alt="speech bubbles icon"
              placeholder="none"
              style={{ opacity: 0.1 }}
            />
          </div>
          <div className='address-item'>
            <div className='address-icon'>
              <StaticImage
                src="../../images/contact/icons/2-2.png"
                loading="eager"
                alt="speech bubbles icon"
                placeholder="none"
              />
            </div>
            <div className='address-text'>
              <h3 className='title'>{title}</h3>
              <p className='services-txt'>
                <a href={`mailto:${address}`}>{address}</a><br />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default EmailWidget;
